import { CardModule, PipesModule } from '@yoimo/joymo-ui';
import { Component, Input, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AccessControlService, ScopeService } from '@core/services';
import { VideoWithDocId } from '@yoimo/client-sdk/videos';
import { localeMapping } from '@core/utilities';
import { ChannelWithDocId } from '@yoimo/client-sdk/channels';

@Component({
  standalone: true,
  imports: [CommonModule, CardModule, RouterModule, PipesModule],
  selector: 'joymo-video-control[video]',
  templateUrl: './video-control.component.html',
  styleUrls: ['./video-control.scss'],
})
export class VideoControlComponent implements OnInit {
  @Input() video!: VideoWithDocId;
  @Input() direction: 'RIGHT' | 'LEFT' = 'RIGHT';
  @Input() linkLabel?: string;
  @Input() channel?: ChannelWithDocId;

  $homepageUrl?: Observable<string>;
  readonly liveLabel = localeMapping['liveLabel'];
  readonly videoLockText = localeMapping['videoLockText'];
  isVideoLocked$?: Observable<boolean>;

  constructor(
    private scopeService: ScopeService,
    private accessControlService: AccessControlService
  ) {}

  ngOnInit(): void {
    this.$homepageUrl = this.scopeService.scope$.pipe(
      map((scope) =>
        scope ? this.scopeService.getHomepageUrlFromScope(scope) : ''
      )
    );
    if (!this.channel) {
      throw new Error('Channel is undefined');
    }
    this.isVideoLocked$ = this.accessControlService.isVideoLocked$(
      this.channel?.docId,
      this.video
    );
  }
}
